module.exports = __webpack_public_path__ + "img/etc-etc-checkbox-sq-dn.c8ac491d.svg";